<div>
    <router-outlet *ngIf="isReady"></router-outlet>
</div>
